<div class="dlg-container">
  <mat-icon *ngIf="isMoveDialog" class="error-icon" svgIcon="save-error" />
  <div class="title">
    <p data-cy="mimics-duplicate-mimic-modal-header">{{ translatedTitle }}</p>
  </div>
  <div *ngIf="data.description" class="description">
    <p>{{ data.description | translate }}</p>
  </div>
  <div class="content">
    <app-input-with-error
      [inputValue]="name"
      [legend]="'mimic-folder.dialog.name.legend'"
      [propertyName]="'name'"
      [validatorFunction]="validatorFunction"
      (onInputUpdated)="nameChange($event)"
      [otherValidationErrors]="titleError"
      maxlength="40"></app-input-with-error>
  </div>
  <div class="selection-container" *ngIf="data.showExtraOptions">
    <mat-radio-group
      class="radio-buttons-container"
      [(ngModel)]="selectionType"
      (ngModelChange)="onSelectionTypeChange($event)">
      <mat-radio-button [value]="ALL">
        {{
          'mimic.page.duplicate-folder.radio-selection.all'
            | translate: { type: (getPluralLabel(selectionLabel) | translate) }
        }}
      </mat-radio-button>

      <mat-radio-button [value]="SELECTED">
        {{
          'mimic.page.duplicate-folder.radio-selection.selected'
            | translate: { type: (getPluralLabel(selectionLabel) | translate) }
        }}
      </mat-radio-button>
    </mat-radio-group>

    <app-dropdown
      name="mimics"
      [label]="
        'mimic.page.duplicate-folder.dropdown.label'
          | translate: { type: (selectionLabel | translate) }
      "
      [itemList]="data.items"
      displayKey="name"
      valueKey="id"
      [value]="selectedItems"
      [isMultipleSelection]="true"
      [isDisabled]="selectionType === ALL"
      (inputChange)="onItemsChange($event)"></app-dropdown>
  </div>

  <div class="button-container">
    <app-button
      text="mimic.create.dialog.button.cancel"
      [size]="BUTTON_MEDIUM_SIZE"
      [variant]="BUTTON_TEXT"
      customFontColor="#1f6873"
      customBorderColor="#1f6873"
      (onClick)="cancelButtonClick()"></app-button>
    <app-button
      [text]="data.submitButtonLabel"
      [disable]="!name || titleError || hasInputErrors || disableLayerEdit"
      [size]="BUTTON_MEDIUM_SIZE"
      (onClick)="saveButtonClick()"></app-button>
  </div>
</div>
